import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Newsletter() {
  const [formData, setFormData] = useState([]);
  const navigate = useNavigate();

  // email section
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // First, send the email
      const emailResponse = await axios.post(
        // "http://ec2-3-109-202-94.ap-south-1.compute.amazonaws.com:3000/send-email",
        "https://api.bgmhotel.com/send-email",
        formData
      );
      alert(emailResponse.data.message); // Alert if email is sent successfully
      // formData.email;

      // toast.success(emailResponse.data.message);

      // Then, save the email to the consumerEmailList
      const saveResponse = await axios.post(
        "https://api.bgmhotel.com/cosumerEmailList",
        { email: formData.email }
      );
      // Reset the form fields
      setFormData({}); // Clear the formData state
      e.target.reset(); // Reset the actual form inputs
      // alert(saveResponse.data.message); // Alert if email is saved successfully
      formData.email = "";
      // toast.success(saveResponse.data.message);
      // email: formData.email = ''
    } catch (error) {
      console.error("Error handling email sending and saving:", error);

      // alert("Failed to send email and save the email.");

      navigate("/");
    }
  };
  return (
    <>
      <div
        className="container newsletter mt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="row justify-content-center">
          <div className="col-lg-10 border rounded p-1">
            <div className="border rounded text-center p-1">
              <div className="bg-white rounded text-center p-5">
                <h4 className="mb-4">
                  Subscribe Our
                  <span className="text-warning text-uppercase">
                    {" "}
                    Newsletter
                  </span>
                </h4>
                <div
                  className="position-relative mx-auto"
                  style={{ maxWidth: "400px" }}
                >
                  <form onSubmit={handleSubmit}>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="form-control w-100 py-3 ps-4 pe-5"
                      placeholder="Enter your email"
                    />
                    {/* <input
                      onChange={handleChange}
                      className="form-control w-100 py-3 ps-4 pe-5"
                      type="text"
                      name=""
                      placeholder="Enter your email"
                    /> */}
                    <button
                      type="submit"
                      className="btn btn-primary-custom py-2 px-3 position-absolute top-0 end-0 mt-2 me-2"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
